import React, {useState} from 'react';
import moment from 'moment';
import {useIntl} from 'react-intl';
import PopupCreateEditTask from '../PopupCreateEditTask/PopupCreateEditTask';
import {taskTypeIDs} from '../../../../constants/taskTypes';
import ButtonAction from '../../../ButtonAction';
import ModalContainer from '../../../ModalContainer';
import ModalHeader from '../../../ModalHeader';
import ModalButtonsContainer from '../../../ModalButtonsContainer';
import ButtonDD from "../../../../../_common/components/ButtonDD";
import {buttonCancel, buttonSubmit, largeButtonsPadding} from '../../../../styles/styles';
import styles from './styles.module.scss';

const GridTaskItem = ({
                        taskID,
                        createDate,
                        taskType,
                        taskTypeID,
                        taskStatus,
                        dueDate,
                        taskDescription,
                        notes,
                        createUserFirstName,
                        createUserLastName,
                        responsibleUserFirstName,
                        responsibleUserLastName,
                        onOpen,
                        onEdit,
                        onDelete
                      }) => {
  const [show, setShow] = useState(false);
  const handleCloseModal = () => setShow(false);
  const handleShowModal = () => setShow(true);
  const intl = useIntl();
  const popupMessage = [intl.formatMessage({
    id: 'tasks-message-delete-task',
    defaultMessage: 'Delete task'
  }), `${taskID}?`].join(' ');

  const getDateBadge = (value) => {
    return value && (
      <div className={'badge'} style={{
        padding: '6px 12px',
        borderRadius: '999px',
        background: 'rgba(255,255,255,0.35)',
        border: '1px solid rgba(0,0,0,0.45)'
      }}>
        <div className="text-dark-75 font-weight-bolder font-size-lg text-nowrap">
          {value}
        </div>
      </div>
    )
  };

  const getTypeBadge = (taskTypeID, taskType) => {
    const getStyles = () => {
      switch (taskTypeID) {
        case 1:
          return {
            background: '#E3F0FB',
            border: '1px solid rgb(56, 189, 248)',
            color: 'rgb(56, 189, 248)'
          };
        case 2:
          return {
            background: '#F9F4E5',
            border: '1px solid rgb(253, 185, 19)',
            color: 'rgb(253, 185, 19)'
          };
        case 3:
          return {
            background: '#CDEADB',
            border: '1px solid rgb(65, 141, 88)',
            color: 'rgb(65, 141, 88)'
          };
        default:
          return null;
      }
    }

    return taskType && (
      <div
        className={'badge badge-pill text-nowrap w-160px font-size-h5'}
        style={getStyles()}
      >
        {taskType}
      </div>
    )
  };

  const cellsArray = [
    {value: taskID},
    {value: getDateBadge(createDate ? moment(createDate).format('DD-MM-YYYY') : '')},
    {value: getTypeBadge(taskTypeID, taskType)},
    {value: taskStatus},
    {value: taskTypeID === taskTypeIDs.visit ? notes : taskDescription},
    {value: getDateBadge(dueDate ? moment(dueDate).format('DD-MM-YYYY') : '')},
    {value: [createUserFirstName, createUserLastName].filter(Boolean).join(' ')},
    {value: [responsibleUserFirstName, responsibleUserLastName].filter(Boolean).join(' ')},
  ];

  const mapRows = (task, index) => {
    return (
      <div key={index} className={'font-weight-bold d-flex align-items-center justify-content-center'}>
        {task.value}
      </div>
    );
  };

  const handleDelete = async () => {
    if (onDelete) {
      await onDelete(taskID);
      handleCloseModal();
    }
  };

  return (
    <div className={styles.taskRow}>
      {cellsArray.map(mapRows)}
      <div className={styles.lastCell}>
        <ButtonDD
          items={[{
            itemContent: (
              <div className="d-flex justify-content-between align-items-center">
                <PopupCreateEditTask
                  taskType={taskTypeID}
                  taskID={taskID}
                  onOpen={onOpen}
                  onEdit={onEdit}
                />
                <div className={'mx-2'}/>
                <ButtonAction
                  variant={'icon'}
                  iconButtonType={'error'}
                  onClick={handleShowModal}
                  label={
                    <img
                      src={'../../../media/common/Delete_red.svg'}
                      alt="delete" className="w-20px h-20px"
                    />
                  }
                />
                <ModalContainer show={show} onHide={handleCloseModal} size={'md'}>
                  <ModalHeader header={popupMessage}/>
                  <ModalButtonsContainer customClassnames={largeButtonsPadding}>
                    <ButtonAction
                      variant={'cancel'}
                      onClick={handleCloseModal}
                      label={intl.formatMessage({id: 'no', defaultMessage: 'No'})}
                      customClassnames={buttonCancel}
                    />
                    <ButtonAction
                      onClick={handleDelete}
                      useIcon={'/media/common/Check-in-circle_white.svg'}
                      label={intl.formatMessage({id: 'yes', defaultMessage: 'Yes'})}
                      customClassnames={buttonSubmit}
                    />
                  </ModalButtonsContainer>
                </ModalContainer>
              </div>
            )
          }
          ]}
        />
      </div>
    </div>
  );
};

export default GridTaskItem;